<template>
  <CCard>
    <CCardHeader>
      <slot name="header">
        <CIcon name="cil-https"/> {{caption}}
        <div class="card-header-actions">
          <CButton color="info" size="sm" @click="storeModal()" v-if="permissions['customers.write'] === true">Nuevo Cliente</CButton>
          <CButton color="success" size="sm" @click="importModal()" v-if="permissions['customers.write'] === true">Importar Clientes</CButton>
        </div>
      </slot>
    </CCardHeader>
    <CCardBody>
      <CDataTable
        :tableFilter="tableFilter"
        :hover="hover"
        :striped="striped"
        :border="border"
        :small="small"
        :fixed="fixed"
        :items="items"
        :fields="fields"
        :items-per-page="100"
        :dark="dark"
        pagination
      >
        <template #position="{item}"><td class="text-center p-0" style="font-size: 12px;">{{item.position}}</td></template>
        <template #code="{item}"><td class="text-center p-0" style="font-size: 12px;">{{item.code}}</td></template>
        <template #name="{item}"><td style="font-size: 12px; padding: 0 0 0 5;">{{item.name}}</td></template>
        <template #supplier_name="{item}"><td class="text-center p-0" style="font-size: 12px;">{{item.supplier_name}}</td></template>
        <template #actions="{item}">
          <td class="table_actions b4 p-1" style="font-size: 12px;">
            <CButton color="info" size="sm" @click="showSales(item)"><CIcon name="cil-zoom"/> Ventas</CButton>
            <CButton color="warning" size="sm" @click="updateModal(item)" v-if="permissions['customers.write'] === true"><CIcon name="cil-pencil"/></CButton>
            <CButton color="danger" size="sm" @click="deleteModal(item)" v-if="permissions['customers.write'] === true"><CIcon name="cil-trash"/></CButton>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
    <CustomerModal ref="customerModal" @store="storeProcess" @update="updateProcess"></CustomerModal>
    <ImportCustomersModal ref="importModal" @import="importProcess"></ImportCustomersModal>
    <DeleteModal ref="deleteModal" @delete="deleteProcess"></DeleteModal>
  </CCard>
</template>

<script>
import ImportCustomersModal from './ImportCustomersModal.vue'
import CustomerModal from './CustomerModal.vue'
import DeleteModal from '../global/DeleteModal.vue'
import ws from '../../services/customers';
import store from '../../store'
import router from '../../router/index'

export default {
  name: 'CustomersTable',
  components: { CustomerModal, ImportCustomersModal, DeleteModal },
  props: {
    items: Array,
    permissions: Object | Array,
    fields: {
      type: Array,
      default () {
        return [
          {key: 'position', label: '#', _style: 'width: 60px; font-size: 12px;'},
          {key: 'code', label: 'Código', _style: 'width: 100px; font-size: 12px;'},
          {key: 'name', label: 'Nombre', _style: 'font-size: 12px;'},
          {key: 'supplier_name', label: 'Vendedor' , _style: 'width: 300px; font-size: 12px;'},
          {key: 'actions', label: 'Acciones', class: 'actions', _style: 'width: 200px; font-size: 12px;'},
        ]
      }
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: Boolean,
    striped: Boolean,
    border: Boolean,
    small: Boolean,
    fixed: Boolean,
    dark: Boolean
  },
  data() {
    return {
      toasts: [],
      tableFilter: {
        label: 'Buscar: ',
        placeholder: '...'
      }
    }
  },
  methods: {
    showSales (item) {
      router.push({path: '/customers/'+item.id+'/'+(this.slugify(item.name))+'/sales'});
    },
    storeModal () {
      this.$refs.customerModal.storeModal();
    },
    updateModal (item) {
      this.$refs.customerModal.updateModal(item);
    },
    deleteModal (item) {
      this.$refs.deleteModal.show("Eliminar Cliente", item.id, item.name);
    },
    async storeProcess(data) {
      let response = await ws.store(data);
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async updateProcess(data) {
      let response = await ws.update(data);

      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    async deleteProcess(id) {
      let response = await ws.delete({id: id});
      
      if(response.type == "success"){
        this.$emit("refresh", response.data );
      }

      this.showToast(response.type, response.message);
    },
    importModal () {
      this.$refs.importModal.importModal();
    },
    async importProcess(data) {
      if(Array.isArray(data)){
        this.$emit("refresh", data);
        return;
      }

      const response = await ws.get();
      if(response.type == "success"){
        this.$emit("refresh", response.data);
      }
    },
    showToast(type, message){
      store.commit('toast', {color: type, message: message});
    },
    loading(){
      store.commit('loading');
    },
    loaded(){
      store.commit('loaded');
    },
    slugify(str) {
      return String(str)
        .normalize('NFKD') // split accented characters into their base characters and diacritical marks
        .replace(/[\u0300-\u036f]/g, '') // remove all the accents, which happen to be all in the \u03xx UNICODE block.
        .trim() // trim leading or trailing whitespace
        .toLowerCase() // convert to lowercase
        .replace(/[^a-z0-9 -]/g, '') // remove non-alphanumeric characters
        .replace(/\s+/g, '-') // replace spaces with hyphens
        .replace(/-+/g, '-'); // remove consecutive hyphens
    }
  }
}
</script>
